module.exports = __webpack_public_path__ + "static/img/icon_cloud_p4.2339e96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud_p4.jpg
// module id = wE38
// module chunks = 21